// extracted by mini-css-extract-plugin
module.exports = {"help-link":"CreateSuppliersExcel_help-link__TgCh1"};